import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';

import { ActionsDrawerItemComponent } from './actions-drawer-item/actions-drawer-item.component';
import { ActionsDrawerComponent } from './actions-drawer.component';

@NgModule({
	imports: [CommonModule, SharedModule],
	declarations: [ActionsDrawerComponent, ActionsDrawerItemComponent],
	exports: [ActionsDrawerComponent, ActionsDrawerItemComponent]
})
export class ActionsDrawerModule { }
